/**
* DevExpress HTML/JS Reporting (rich-edit\instance.js)
* Version:  23.1.4
* Build date: Jul 18, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { createGlobalModuleVariableFunc } from '@devexpress/analytics-core/analytics-internal';
var richEditInstance = null;
export var getRichEditInstance = function () {
    if (!richEditInstance) {
        richEditInstance = require('devexpress-richedit');
    }
    return richEditInstance;
};
export var createRichEdit = createGlobalModuleVariableFunc((element, options) => getRichEditInstance().create(element, options));
export var createRichEditOptions = createGlobalModuleVariableFunc(() => getRichEditInstance().createOptions());
